
<c-auto-form config="recipientCtrl.autoFormConfig"></c-auto-form>

<div class="popup-button-content">
    <div>
        <span><button class="popup-msg-button btn-primary" ng-click="recipientCtrl.ok()"><span>{{'save'|translate}}</span></button></span>
        <span><button class="popup-msg-button" ng-click="recipientCtrl.remove()"><span>{{'remove'|translate}}</span></button></span>
        <span><button class="popup-msg-button" ng-click="recipientCtrl.cancel()"><span>{{'popup.cancel'|translate}}</span></button></span>
    </div>
</div>